// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_zec","cls2":"Header-cls2_V07 Header-cls1_zec"};